import React from 'react';
import thunk from 'redux-thunk';
import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router-dom';
import { createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';

import reducer from '../reducers/index';
import router from '../routes';

const Root = () => {
    const store = getReduxStore();

    return (
        <Provider store={store}>
            <RouterProvider router={router}/>
        </Provider>
    );
};

const getReduxStore = () => {
    if (process.env.NODE_ENV === 'production') {
        return createStore(reducer, applyMiddleware(thunk));
    }

    return createStore(reducer, composeWithDevTools(applyMiddleware(thunk)));
};

export default Root;
